const quarters = (function() {

  const self = {

    quarterOfDate (date: Date) {
      if (!date) return null
      return '' + ( Math.floor( date.getMonth() / 3 ) + 1 ) + 'Q' + date.getFullYear()
    },

    currentQuarter () {
      return self.quarterOfDate(new Date())
    },

    currentYear () {
      const date = new Date()
      return date.getFullYear()
    },

    lastYear () {
      const date = new Date()
      return (date.getFullYear() - 1)
    }

  }

  return self
})();

export default quarters
